import Quill from 'quill';

const Block = Quill.import('blots/block');

/**
 * Quill/Parchment Blot to allow block shortcode placeholders
 * @class DropcapShortcodeBlot
 * @extends BlockShortcodeBlot
 */
export class DropcapShortcodeBlot extends Block {
  /** @inheritdoc */
  static blotName: string = 'dropcapShortcode';

  /** @inheritdoc */
  static tagName: string = 'P';

  /** @inheritdoc */
  static create(formats: any) {
    const node = super.create(formats);
    for (const format in formats) {
      if (formats.hasOwnProperty(format)) {
        node.setAttribute(format, formats[format]);
      }
    }
    return node;
  }

  /** @inheritdoc */
  static formats(domNode) {
    if (this.isDropcap(domNode)) {
      const formats = {'data-dropcap': true};
      return formats;
    }
    return super.formats(domNode);
  }

  static isDropcap(domNode) {
    return domNode.dataset && domNode.dataset.dropcap;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/shortcode/block/dropcap/dropcap.shortcode.blot.ts